export const getTagAttr = (attrs = '', key = '') => {
  const match = attrs.match(new RegExp(`${key}\\s*=\\s*["']([^"']+)["']`, 'i'))
  return match?.[1] || ''
}

const getNumberTagAttr = (attrs = '', key = '') => {
  const value = Number(getTagAttr(attrs, key))
  return Number.isFinite(value) && value > 0 ? value : 0
}

const getDetailData = (attrs = '') => {
  const id = getNumberTagAttr(attrs, 'behavingId')
  if (!id) return {}

  const businessType = getNumberTagAttr(attrs, 'businessType')
  const businessDataId = getNumberTagAttr(attrs, 'businessDataId')
  const showName = getTagAttr(attrs, 'showName')
  const creatorName = getTagAttr(attrs, 'creatorName')
  const creatorTime = getTagAttr(attrs, 'creatorTime')

  if (businessType === 8000) {
    // 线索
    return {
      id,
      detailType: 'clue',
      showName,
      creatorName,
      creatorTime,
      ...(businessDataId && { clueId: businessDataId })
    }
  } else if (businessType === 100) {
    // 客户
    return {
      id,
      detailType: 'customer',
      showName,
      creatorName,
      creatorTime,
      ...(businessDataId && { customerId: businessDataId })
    }
  }
}

const renderEvidencePlaceholder = (attrs = '', env = {}) => {
  if (!Array.isArray(env.evidences)) {
    env.evidences = []
  }

  const id = `evidence-${env.evidences.length}`
  const fileName = getTagAttr(attrs, 'fileName')
  const reason = getTagAttr(attrs, 'reason')
  const deatilData = getDetailData(attrs)

  env.evidences.push({
    id,
    props: {
      isFollowSource: Boolean(getNumberTagAttr(attrs, 'behavingId')),
      fileName,
      reason,
      deatilData
    }
  })

  return `<span data-evidence-id="${id}"></span>`
}

export const evidencePlugin = (md) => {
  const defaultHtmlInline = md.renderer.rules.html_inline || ((tokens, idx) => tokens[idx].content)
  const defaultHtmlBlock = md.renderer.rules.html_block || ((tokens, idx) => tokens[idx].content)
  const evidenceTagReg = /^<evidence\s+([^>]*?)\/>$/i

  const renderEvidenceTag = (content, env) => {
    const match = content.trim().match(evidenceTagReg)

    return match ? renderEvidencePlaceholder(match[1], env) : ''
  }

  md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
    const content = tokens[idx].content
    return renderEvidenceTag(content, env) || defaultHtmlInline(tokens, idx, options, env, self)
  }

  md.renderer.rules.html_block = (tokens, idx, options, env, self) => {
    const content = tokens[idx].content
    const lines = content.split('\n')
    const renderedLines = lines.map((line) => renderEvidenceTag(line, env) || line)

    if (renderedLines.every((line, index) => line === lines[index])) {
      return defaultHtmlBlock(tokens, idx, options, env, self)
    }

    return renderedLines.join('\n')
  }
}
